import { render, staticRenderFns } from "./ExamDownloadKDR.vue?vue&type=template&id=f39576fa&"
import script from "./ExamDownloadKDR.vue?vue&type=script&lang=js&"
export * from "./ExamDownloadKDR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports